import BlockView from 'views/block/base-block-view';
import EnrollmentDataService from 'services/enrollment-data-service';
import {
  LocalStorageService,
  SessionStorageService
} from 'services/web-storage-service';
const AhoyService = require('services/ahoy-service');

export default class DataView extends BlockView {
  constructor(options) {
    super(options);

    this.services = {
      enrollment: EnrollmentDataService.saveData,
      session: SessionStorageService.setItem,
      local: LocalStorageService.setItem
    };

    this.service = { // normalize the services so that there is a save method that takes key/value
      save: this.services[this.model.get('service')] ? this.services[this.model.get('service')] : EnrollmentDataService.saveData
    };
  }

  save(item) {
    const serviceName = this.model.get('service');
    Object.entries(item).forEach(([key, value]) => {
      this.service.save(key, value);
      AhoyService.track('data', {action: 'save', service: serviceName, key: key, value: value});
    });
  }

  load() {
    if(this.model.has('data')) {
      const data = this.model.get('data');
      if(Array.isArray(data)) {
        data.forEach(item => {
          this.save(item);
        });
      } else if(data && typeof data === 'object') {
        this.save(data);
      }
    }
  }

  play() {
    this.readyToGo();
  }
}
